<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<div class="margin-top">
			<div>
				<div class="flex">
					<div class="margin-right">
						<select v-model="splitPaymentPlan">
							<option value="">Delete scheduled payments</option>
							<option value="1">Instant</option>
							<option value="2">50% instant / 50% next month</option>
							<option value="3">100% next month</option>
							<option value="4">50% next month / 50% month after</option>
						</select>
					</div>
				</div>

				<div class="margin-top">
					<button :disabled="saving" v-on:click="updateSplitPayment()">Change plan</button>
					<button class="small-margin-left" :disabled="saving" v-on:click="createSplitPayment()">+ Create payment</button>
				</div>
			</div>

			<table v-if="splitPayments.length > 0" class="margin-top">
				<thead>
					<tr>
						<th>#</th>
						<th>Payment date</th>
						<th>Other triggers</th>
						<!-- <th>Rate</th> -->
						<th>Status</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(payment) in splitPayments">
						<td>{{ payment.id }}</td>
						<td>
							<input type="text" v-model="payment.payment_date" :disabled="saving" v-on:keyup.enter="savePayment(payment)" />
						</td>
						<td>{{ payment.triggers }}</td>
						<td>
							<span v-if="payment.captured_at && payment.capture_attempted_at">
								<span class="success">Completed</span>
							</span>
							<span v-if="!payment.captured_at && payment.capture_attempted_at">
								<span class="error">Failed</span>
							</span>
							<span v-if="!payment.captured_at && !payment.capture_attempted_at">
								Pending
							</span>
						</td>
						<td>
							<button :disabled="saving" v-if="!payment.captured_at" v-on:click="setPaymentCaptured(payment.id, true)">Mark as captured</button>
							<button :disabled="saving" v-if="payment.captured_at" v-on:click="setPaymentCaptured(payment.id, false)">Unmark as captured</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  props: [
    'id'
  ],
  data: () => ({
    loading: false,
    saving: false,
    reset: true,
    records: [],
    splitPaymentPlan: '',
    splitPayments: []
  }),
  methods: {
    savePayment (payment) {
      Vue.$api.patch('/scheduled-payment/' + payment.id, {
        payment_date: payment.payment_date
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => alert('Saved')
      })
    },
    setPaymentCaptured (id, captured) {
      Vue.$api.patch('/scheduled-payment/' + id + '/capture-status', {
        captured: captured
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    },
    load () {
      Vue.$api.get('/order/' + this.id + '/scheduled-payments', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.splitPayments = data.payments
    },
    updateSplitPayment () {
      Vue.api.put('/split-payment/' + this.id, {
        plan: this.splitPaymentPlan,
        reset: this.reset
      }, {
        loader: toggle => this.saving = toggle,
        callback: () => this.load()
      })
    },
    createSplitPayment () {
      Vue.$api.post('/order/' + this.id + '/scheduled-payment', {}, {
        loader: toggle => this.saving = toggle,
        callback: data => this.load()
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
